<template>
  <div>
    <a-row>
      <g-master name="formsheaders"
                :endpoint="formsHeaderMaster.endpoint"
                :tableSetup="formsHeaderMaster.tableSetup"
                :parentData="fhParentData"
                :modalFieldsSetup="formsHeaderMaster.modalFieldsSetup"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Orden')">
                <a-input-number style="width: 100%"
                                v-decorator="['orden', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                ></a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="COMPONENTES" key="1">
          <forms_components v-if="idHeader" :id_header="idHeader"></forms_components>
          <span v-else>Seleccione para ver los componentes.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {

    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        formsHeaderMaster: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'forms_header',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Orden', dataIndex: 'orden', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'orden'},
            {name: 'status'}
          ]
        }
      }
    },
    props: ['id_form'],
    computed: {
      fhParentData () {
        return {
          id_form: this.id_form
        }
      },
      idHeader () {
        return this.formsHeaderMaster.tableSetup.selectedRows.length > 0 ? this.formsHeaderMaster.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Form/FormsHeaders.vue